import { render, staticRenderFns } from "./MvPlayerWebRtc.vue?vue&type=template&id=499f1ae4&scoped=true"
import script from "./MvPlayerWebRtc.vue?vue&type=script&setup=true&lang=js"
export * from "./MvPlayerWebRtc.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MvPlayerWebRtc.vue?vue&type=style&index=0&id=499f1ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499f1ae4",
  null
  
)

export default component.exports